import rest from './rest';


async function index(device, options) {
  const response = await rest.get('/events', {diode: device, ...options});
  return response.events;
}

async function last(device) {
  const response = await rest.get('/events', {diode: device, after: -1});
  if (Array.isArray(response.events) && response.events.length) {
    return response.events[0].ingested;
  }
  return null;
}

export default {
  index,
  last
};
